import { render } from "./PopupForm.vue?vue&type=template&id=4732a7b8&scoped=true"
import script from "./PopupForm.vue?vue&type=script&lang=js"
export * from "./PopupForm.vue?vue&type=script&lang=js"

import "./PopupForm.vue?vue&type=style&index=0&id=4732a7b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4732a7b8"]])

export default __exports__